import React from "react";

import "./CardBack.scss";

const CardBack = ({ className, children }) => {
    return <div className={`CardBack ${className}`}>{children}</div>;
};

export default CardBack;
